import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';
import { colorPrimary } from '../../theme';

interface ToggleButtonProps {
	collapsed?: boolean;
}

export const Container = styled.section<ToggleButtonProps>`
	display: flex;
	position: relative;
	${({ collapsed }) => (collapsed ? '' :'gap: 24px;')};
	padding: 32px 16px;
	margin: auto;
	max-width: 1200px;
	width: 100%;
	flex-direction: column;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: row;
	}
`;

export const ProfileAside = styled.aside<ToggleButtonProps>`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	display: flex;
	flex-direction: column;
	width: 100%;
	${({ collapsed }) => (collapsed ? '' : 'padding: 16px')};
	border-radius: 12px;
	height: fit-content;
	transition: all 0.5s;
	position: relative;

	&::after {
		display: ${({ collapsed }) => (collapsed ? 'block' : 'none')};
		text-align: center;
	}

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		width: 276px;
	}
`;

export const ProfilePages = styled.nav`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Separator = styled.hr`
	height: 1px;
	padding: 0;
	margin: 16px 0;
	border: none;
	width: 100%;
	background-color: #ced4da;
`;

export const PageContent = styled.div<ToggleButtonProps>`
	display: flex;
	flex: ${({ collapsed }) => (collapsed ? '1 0 100%' : '1')};
	flex-direction: column;
	transition: all 0.5s;
`;

export const SectionTitle = styled.div`
	${({ theme }) => theme.typography.headlines.h5};
`;

export const TitleContainer = styled.h1`
	${({ theme }) => theme.typography.headlines.h5};
`;

export const FullLine = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const FullLineLooker = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	width: 100wh;
`;

export const HalfLine = styled.div``;
export const HalfLineButton = styled.div``;

export const Form = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns:  repeat(3, 1fr);

		${FullLine} {
			grid-column: 1 / -1;
		}

		${FullLineLooker} {
			grid-column: 1 / -1;
		}

		${HalfLine} {
			grid-column: span 1;
		}

		${HalfLineButton} {
			grid-column: span 1;
			align-content: flex-end;
		}
	}
`;

export const TableContainer = styled.div`
	width: 100%;
	padding: 24px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const NoData = styled.div`
	text-align: center;
	padding: 50px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	overflow-x: auto;
`;

export const ToggleButton = styled.button<ToggleButtonProps>`
	display: block;
	position: absolute;
	cursor: pointer;
	top: 6px;
	left: 16px;
	background: none;
	border: none;
	font-size: 12px;
	background-color: ${colorPrimary};
    color: white;
    padding: 4px;
    border-radius: 6px;
`;